//车辆管理
export default [
    {
        alias: '',
        path: 'deviceManagement',
        name: 'deviceManagement',
        meta: {
            title: '车辆管理',
            icon: 'deviceManagement'
        },
        hidden: false,
        component: () => import("@/views/equipment/deviceManagement/index.vue"),
        children: [{
            alias: '',
            path: 'equipmentMode',
            name: 'equipmentMode',
            meta: {
                title: '车辆型号',
                icon: 'equipmentMode'
            },
            hidden: false,
            component: () => import("@/views/equipment/deviceManagement/equipmentMode.vue"),
        },{
            path: 'equipmentList',
            name: 'equipmentList',
            meta: {
                title: '车辆列表',
                icon: 'equipmentList'
            },
            hidden: false,
            component: () => import("@/views/equipment/deviceManagement/equipmentList.vue"),
        },{
            path: 'equipmentInfo',
            name: 'equipmentInfo',
            meta: {
                title: '车辆详情',
                icon: 'equipmentInfo'
            },
            hidden: true,
            component: () => import("@/views/equipment/deviceManagement/equipmentInfo.vue"),
        }]
    }

]